import { BaseService } from "mrb/core";
import { LoadioStoreFeaturedSectionFileStreamApiRouteService } from "common/services";

class LoadioStoreFeaturedSectionFileStreamService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioStoreFeaturedSectionFileStreamApiRouteService());
    }

    get(id, params, abortSignal = null) {
        const url = this.routeService.get(id, params);
        return this.apiClient.get(url, null, abortSignal);
    }

    getFeaturedSectionCoverImageByGridItemId(featuredSectionItemId, params, abortSignal = null) {
        const url = this.routeService.getFeaturedSectionCoverImageByItemId(featuredSectionItemId, params);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default LoadioStoreFeaturedSectionFileStreamService;
